<template>
	<div class="page">
		<div class="header">
			<van-image
				v-if="patientInfo.userDTO.avatar"
				:src="patientInfo.userDTO.avatar"
				width="55"
				height="55"
			></van-image>
			<van-image v-else :src="avatar" width="55" height="55"></van-image>
			<span class="name">{{ patientInfo.userDTO.username }}</span>
		</div>

		<div class="grid">
			<span class="tag">常用工具</span>
			<div>
				<dl
					v-for="(tools, index) in toolsList"
					:key="`tag_${ index }`"
					@click="clickItem(tools)"
				>
					<dd>
						<van-image :src="tools.img" width="29" height="29"></van-image>
					</dd>
					<dt>{{tools.text}}</dt>
				</dl>
			</div>
		</div>
	</div>
</template>

<script>
const avatar = require('../../assets/img/avatar.png')
export default {
	name: "personal",
	data() {
		return {
			avatar,
			toolsList: [{
				img: require('../../assets/icon/order.png'),
				text: '我的订单',
				url: '/order/list'
			},{
				img: require('../../assets/icon/report.png'),
				text: '我的报告',
				url: '/report/list'
			},{
				img: require('../../assets/icon/agreement.png'),
				text: '用户协议',
				url: '/agreement/fuwu'
			},{
				img: require('../../assets/icon/notes.png'),
				text: '隐私政策',
				url: '/agreement/yinsi'
			},{
				img: require('../../assets/icon/power.png'),
				text: '退出登录',
				event: 'logout'
			}]
		}
	},
	computed: {
		patientInfo () {
			return this.$store.getters['account/patientInfo']
		}
	},
	mounted () {
		this.$store.dispatch('account/getUserInfo')
	},
	methods: {
		clickItem (item) {
			if (item.url) {
				this.$router.push(item.url)
			} else if (item.event) {
				switch (item.event) {
					case 'logout':
						this.logout();
						break;
				}
			}
		},
		logout () {
			this.$dialog.confirm({
				title: '',
				message: '确定要出登录吗？'
			}).then(() => {
				return this.$api.account.logout()
			}).then(res => {
				if (!res.code) {
					this.$toast('退出成功')
					this.$store.commit('account/CLEAR')
					this.$router.replace('/account/login')
				}
			}).catch(() => {})
		}
	}
}
</script>

<style scoped>
dl, dd ,dt {
	margin: 0;
	padding: 0;
}

.page {
	padding: 4.27vw;
}

.header {
	display: flex;
	justify-items: center;
	align-items: center;
}

.name {
	margin-left: 3.2vw;
	font-size: 5.33vw;
	font-weight: 500;
	line-height: 6.4vw;
	color: #333333;
}

.grid {
	margin-top: 5.33vw;
	padding: 4.27vw 3.73vw;
	border-radius: 2.13vw;
	background: #FFFFFF;
}

.grid > div {
	display: flex;
	flex-wrap: wrap;
}

.grid > span {
	font-weight: 500;
}

.grid dl {
	width: 20.8vw;
	margin-top: 6.67vw;
}

.grid dl dt, .grid dl dd {
	text-align: center;
}

.grid dl dt {
	margin-top: 2.67vw;
	font-size: 3.47vw;
	line-height: 4vw;
	color: #333333;
}

.tag {
	font-size: 4.27vw;
	font-weight: 400;
	line-height: 5.07vw;
	color: #333333;
}
</style>
